<template lang="html">
  <div>
    <v-dialog
      v-model="MemberGroup"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      <v-card :style="stylechat">
        <v-layout row wrap justify-center align-center class="pt-5 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pl-2 pr-0 pt-0 pb-0 cursor"
            @click="closeDialog"
          >
            <v-icon class="fz-30">mdi-chevron-left</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('RightSide.member')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0 cursor"
            v-if="MemberGroupDetail.state === 'active'"
            >
            <span class="icon-color" v-if="!edit_member" @click="editGroup(true)">{{$t('AnswerQuestion.edit')}}</span>
            <span class="icon-color" v-else @click="editGroup(false)">{{$t('AnswerQuestion.ok')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            v-else
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout row wrap justify-start align-center class="pt-5 pl-5 pr-5 pb-3">
          <v-text-field
            ref="search"
            v-model="search"
            :placeholder="$t('LeftSide.addFiend.searching')"
            prepend-inner-icon="mdi-magnify"
            solo
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-layout>
        <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-5">
          <v-list
            subheader
            two-line
            class="list-overflow"
          >
            <v-subheader v-if="FilterListActive.length !== 0">{{$t('RightSide.member')}} ({{MemberGroupDetail.count_member}})</v-subheader>
            <template v-for="(item, index) in FilterListActive">
              <v-list-item :key="item.tokenuser">
                <v-list-item-action v-if="edit_member && item.tokenuser !== data_user.tokenuser" @click="openDialog(item, index, 'kickgroup')">
                  <v-icon color="red" class="cursor">mdi-minus-circle</v-icon>
                </v-list-item-action>
                <v-list-item-avatar class="mr-3">
                  <img v-if="item.profile" :src="item.profile" alt="" class="img-position">
                  <img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{item.status}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index < FilterListActive.length - 1"
              ></v-divider>
            </template>
            <!-- list pending -->
            <v-subheader v-if="FilterListPending.length !== 0">{{$t('RightSide.pending')}} ({{MemberGroupDetail.count_pending}})</v-subheader>
            <template v-for="(item, index_pending) in FilterListPending">
              <v-list-item :key="item.tokenuser">
                <v-list-item-action v-if="edit_member && item.tokenuser !== data_user.tokenuser" @click="openDialog(item, index_pending, 'cancelinvite')">
                  <v-icon color="red" class="cursor">mdi-minus-circle</v-icon>
                </v-list-item-action>
                <v-list-item-avatar>
                  <img v-if="item.profile" :src="item.profile" alt="" class="img-position">
                  <img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{item.status}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index_pending < FilterListPending.length - 1"
              ></v-divider>
            </template>

          </v-list>
        </v-layout>
      </v-card>
    </v-dialog>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import WarningDialog from '@/components/Alert/Warning'
import ErrorDialog from '@/components/Alert/Error'
export default {
  props: {
    MemberGroup: Boolean,
    MemberGroupDetail: {}
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      ErrorDialogDetail: {},
      ErrorDialog: false,
      WarningDialogDetail: {},
      WarningDialog: false,
      data_user: {},
      edit_member: false,
      member_active: [],
      member_pending: [],
      progress: false,
      search: '',
      stylechat: {
        "--MemberGroup-HeaderColor": "white",
        "--MemberGroup-TabBackground": "white",
        "--MemberGroup-Icon": "gray",
        "--MemberGroup-IconActive": "#2662ae",
        "--MemberGroup-Background": "white",
        "--MemberGroup-FontSize": "18px",
        "--MemberGroup-FontSize-Title": "24px",
        "--MemberGroup-FontColor": "back",
        "--MemberGroup-FontSize-Status": "16px",
        "--MemberGroup-FontColor-Status": "grey",
        "--MemberGroup-Background-Input": "#E2E1E3",
        "--MemberGroup-Color-Button": "#EFF2FE",
        "--MemberGroup-FontColor-Button": "#2662ae",
        "--MemberGroup-FontColor-Block-Button": "#cb1002",
        "--MemberGroup-FontColor-Dis-Button": "#e2e1e3",
        "--MemberGroup-Btn-Confirm-Background": "#2662ae",
        "--MemberGroup-Btn-Confirm-Color": "white",
        "--MemberGroup-Btn-Confirm-FontSize": "18px",
        "--MemberGroup-Btn-Cancel-Background": "white",
        "--MemberGroup-Btn-Cancel-Color": "#2662ae",
        "--MemberGroup-Btn-Cancel-FontSize": "18px",
        "--MemberGroup-Btn-Leave-Background": "white",
        "--MemberGroup-Btn-Leave-Color": "#ff5252",
        "--MemberGroup-Btn-Leave-FontSize": "18px"
      },
    }
  },
  components: {
    WarningDialog,
    ErrorDialog
  },
  computed: {
    FilterListActive () {
      if (this.search !== '' && this.search !== null) {
        return this.member_active.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.member_active
      }
    },
    FilterListPending () {
      if (this.search !== '' && this.search !== null) {
        return this.member_pending.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.member_pending
      }
    },
  },
  watch: {
    MemberGroup() {
      if (this.MemberGroup) {
        // console.log(this.MemberGroupDetail)
        this.member_active = _.filter(this.MemberGroupDetail.member, function (o) { return o.statemember === 'active' })
        this.member_pending = _.filter(this.MemberGroupDetail.member, function (o) { return o.statemember === 'pending' })
      }
    }
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    closeAlertDialog (data) {
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    emitWarning (item) {
      this.WarningDialog = false
      if (item.type === 'kickgroup') {
        this.kickGroup(item)
      } else if (item.type === 'cancelinvite') {
        this.cancelInvite(item)
      }
    },
    openDialog (item, index, type) {
      // console.log(item)
      if (type === 'kickgroup') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Right.deleteFriendGroup', {name: item.name}),
          detail: item,
          index: index,
          type: 'kickgroup'
        }
        this.WarningDialog = true
      } else if (type === 'cancelinvite') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Right.cancelInvite', {name: item.name}),
          detail: item,
          index: index,
          type: 'cancelinvite'
        }
        this.WarningDialog = true
      }
    },
    kickGroup (item) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/kick-group`, {
        group_id: this.MemberGroupDetail.group_id,
        listmember: [item.detail.tokenuser],
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.member_active.splice(item.index, 1)
          this.edit_member = false
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    cancelInvite (item) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/cancelsendinvite`, {
        group_id: this.MemberGroupDetail.group_id,
        tokenfriend: item.detail.tokenuser,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.member_pending.splice(item.index, 1)
          this.edit_member = false
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeDialog() {
      this.$emit('closeComponents', {
        name: 'membergroup',
        value: false
      })
      this.edit_member = false
    },
    editGroup (value) {
      this.edit_member = value
    }
  },
}
</script>

<style lang="css" scoped>
.cursor {
    cursor: pointer;
}
.list-overflow {
  height: calc(100vh - 120px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-input__slot {
  background-color: var(--MemberGroup-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--MemberGroup-Icon) !important;
}
.icon-color {
  color: var(--MemberGroup-IconActive) !important;
}
.btn-confirm {
  background-color: var(--MemberGroup-Btn-Confirm-Background) !important;
  color: var(--MemberGroup-Btn-Confirm-Color) !important;
  font-size: var(--MemberGroup-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--MemberGroup-Btn-Cancel-Background) !important;
  color: var(--MemberGroup-Btn-Cancel-Color) !important;
  font-size: var(--MemberGroup-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--MemberGroup-Btn-Leave-Background) !important;
  color: var(--MemberGroup-Btn-Leave-Color) !important;
  font-size: var(--MemberGroup-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--MemberGroup-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--MemberGroup-FontSize-Title) !important;
  color: var(--MemberGroup-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--MemberGroup-FontColor) !important;
  font-size: var(--MemberGroup-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--MemberGroup-FontColor-Status) !important;
  font-size: var(--MemberGroup-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
